// src/services/MarketService.js

/**
 * Service to fetch market commodity prices.
 * SIMULATION: Values are cached for 10 minutes to prevent user confusion.
 */

const BASE_PRICES = {
    CORN: 6.75,
    WHEAT: 7.20,
    SOYBEANS: 13.50,
    RICE: 16.80
};

// Cache to store the 'current' market prices for the session
let cachedPrices = null;
let lastFetchTime = 0;
const CACHE_DURATION = 600000; // 10 minutes

export const marketService = {
    /**
     * Get stable market prices
     */
    async getMarketPrices() {
        const now = Date.now();

        // Return cached data if fresh enough
        if (cachedPrices && (now - lastFetchTime < CACHE_DURATION)) {
            return cachedPrices;
        }

        // Otherwise generate new data
        cachedPrices = [
            this.generatePrice('Corn', BASE_PRICES.CORN),
            this.generatePrice('Wheat', BASE_PRICES.WHEAT),
            this.generatePrice('Soybeans', BASE_PRICES.SOYBEANS),
            this.generatePrice('Rough Rice', BASE_PRICES.RICE)
        ];

        lastFetchTime = now;
        return cachedPrices;
    },

    /**
     * Generate a realistic price object
     */
    generatePrice(name, base) {
        // Small fluctuation only when cache expires
        const changePercent = (Math.random() * 2) - 1;
        const currentPrice = base * (1 + (changePercent / 100));

        return {
            id: name.toLowerCase(),
            name: name,
            price: currentPrice.toFixed(2),
            change: changePercent.toFixed(2),
            unit: 'USD/bu',
            trend: changePercent >= 0 ? 'up' : 'down',
            lastUpdated: new Date().toLocaleTimeString()
        };
    }
};
